module.exports = __webpack_public_path__ + "static/logos/snow-forecast__logo--white-9b5c2a890a9cf26e672582f1fc87dd84.svg";